import React from 'react'
import './VideoItem.css';
import './SideBar/style.css'
const VideoItem = ({video,onVideoSelect}) => {
    return (
       //we need to pass the video as arguments to call onclick video {/*  */}
        <div onClick={()=>onVideoSelect(video)} className="video-item item ">
       <span className="btn btn-white b-animated"> <img className="btn btn-white b-animated" style={{opacity: 1,transitionProperty:'opacity'}} src={video.urlCover} alt={video.title}/>
            <div className="content ">
         <div className="header ">{video.title}</div> 
         <div className="header">{video.EntryDate}</div>
         </div>{/***src={video.url} */} {/***src={video.title} */}
         </span>
        </div>
        
    )
}

export default VideoItem